export default __webpack_public_path__ + "static/media/card-games.0939608b.png";